export const APP_ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  PAGE_NOT_FOUND: '/page-not-found',
};

export const DASHBOARD_NON_SIDEBAR_ROUTES = {
  VENDOR_LOUNGE: '/vendor-lounge',
  VENDOR_PROFILE: '/vendor-profile',
  ADD_VENDOR_MANUAL: '/add-vendor-manual',
  MEMBER_PROFILE: '/member-profile',
  PROFILE: '/profile',
  SEARCH_PANEL: '/search-panel',
};

export const DASHBOARD_SIDEBAR_ROUTES = {
  HOME: '/dashboard',
  CONCEIRGE: '/concierge',
  VENDOR_HUB: '/vendor-hub',
  COMMUNITY: '/community',
  YOUZAK: '/youzak',
  INVITE: '/invite',
  SUPPORT: '/support',
  ...DASHBOARD_NON_SIDEBAR_ROUTES,
};
